export const cityCodeToCitySlug = cityCode => {
  if (!cityCode.includes('-')) {
    return cityCode;
  }

  const [, ...city] = cityCode.split('-');

  return city.join('-');
};
